import { render, staticRenderFns } from "./Koutu_Price_2.vue?vue&type=template&id=4cc4834e&scoped=true"
import script from "./Koutu_Price_2.vue?vue&type=script&lang=js"
export * from "./Koutu_Price_2.vue?vue&type=script&lang=js"
import style0 from "./Koutu_Price_2.vue?vue&type=style&index=0&id=4cc4834e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cc4834e",
  null
  
)

export default component.exports